import { useSelector } from 'react-redux';
import { rm } from 'utils';
import styles from './styles.scss';
import { selectPhoneNumber, selectOpeningHours } from '../../selector';
import { IconPhone } from 'components/Shared/Icon/themes/BGH-RD3/iconPhone';
import { selectChannel } from 'components/Header/themes/BGH/selector';
import { isUWChannel } from 'components/Shared/channel';

export const HelpSection = () => {
  const phoneNumber = useSelector(selectPhoneNumber);
  const openingHours = useSelector(selectOpeningHours);
  const showOpeningHours = isUWChannel(useSelector(selectChannel)) === false;

  return (
    <div className={styles.helpContainer}>
      <div className={styles.helpContent}>
        <h3>{rm('checkout_contact_header')}</h3>
        <span>{rm('checkout_contact_body')}</span>
        <a className={styles.phone} href={`tel:${phoneNumber}`}>
          <IconPhone className={styles.icon} />
          {phoneNumber}
        </a>
        {showOpeningHours && openingHours && <span>{openingHours}</span>}
      </div>
    </div>
  );
};
